<script lang="ts" setup>
import type { PropType } from 'vue'
import PierPassFeeSection from './PierPassFeeSection.vue'
import type { CleanTruckFee, PierPass } from '~/models/pierPass'
import type { Container } from '~/models/containers'

const props = defineProps({
  pierPass: { type: Object as PropType<PierPass>, required: true },
  cleanTruckFee: { type: Object as PropType<CleanTruckFee>, required: true },
  container: { type: Object as PropType<Container>, required: true },
})

const pierPassWithTimes = computed(() => ({
  ...props.pierPass,
  last_observed: props.pierPass?.last_observed ?? null,
  last_observed_changed: props.pierPass?.last_observed_change ?? null,
}))
</script>

<template>
  <div class="mb-1">
    <ObjectChangeTimesDisplay :object="pierPassWithTimes" />
    <RefreshPierPassButton :pier-pass="props.pierPass" class="ml-2" />
  </div>

  <PierPassFeeSection title="Clean Truck Fee" :data="cleanTruckFee" />
  <PierPassFeeSection title="Traffic Mitigation Fee" :data="pierPass" />
</template>
